import React, { createContext, useMemo } from 'react';

export type Props = {
	issueId: number;
	issueKey: string;
	workType?: string | null;
	isCreateSubTaskAllowed?: boolean;
	onIssueRefetch?: (issueKey: string) => void;
	onIssueDelete?: (issueKey: string) => void;
};

const initialState: Props = {
	issueId: 0,
	issueKey: '',
};

export const propsContext = createContext<Props>(initialState);

export const PropsProvider = ({
	issueId,
	issueKey,
	workType,
	isCreateSubTaskAllowed,
	onIssueRefetch,
	onIssueDelete,
	children,
}: React.PropsWithChildren<Props>) => {
	const value = useMemo(
		() => ({
			issueId,
			issueKey,
			workType,
			isCreateSubTaskAllowed,
			onIssueRefetch,
			onIssueDelete,
		}),
		[issueId, issueKey, workType, isCreateSubTaskAllowed, onIssueRefetch, onIssueDelete],
	);

	return <propsContext.Provider value={value}>{children}</propsContext.Provider>;
};
